import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalComponent} from './modal.component';
import {ConfirmDialogComponent} from './confirmdialog/confirmdialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {ModalActionComponent} from './modal-action/modal-action.component';
import {MatDividerModule} from '@angular/material/divider';

import {MatDatepickerModule} from '@angular/material/datepicker';
import {ModalErrorComponent} from './modal-error/modal-error.component';
import {ModalYNComponent} from './modal-yn/modal-yn.component';
import {DeleteDialog} from './delete/delete-dialogs.component';

import {WhitebuttonModule} from '../whitebutton/whitebutton.module';
import {ModalExitModule} from "./modal-exit/modal-exit.module";

@NgModule({
  declarations: [
    ModalComponent,
    ConfirmDialogComponent,
    ModalActionComponent,

    ModalErrorComponent,
    ModalYNComponent,
    DeleteDialog,

  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatDividerModule,
    MatDatepickerModule,
    WhitebuttonModule,
    ModalExitModule,


  ],
  exports: [ModalComponent,
    MatDatepickerModule]
})
export class ModalModule {
  constructor() {}
}
